import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Delivery from "./Component/Delivery";
import FAQs from "./Component/FAQs";
import CookiePolicy from "./Component/CookiePolicy";
import PolicyCenter from "./Component/PolicyCenter";
import PolicyPage from "./Component/PolicyPage";
import { policyCatalog } from "./Component/policyCatalog";

function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/policies" element={<PolicyCenter />} />
          {policyCatalog.map((policy) => (
            <Route
              key={policy.path}
              path={`/${policy.path}`}
              element={<PolicyPage policy={policy} />}
            />
          ))}
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
